module.exports = {"id":"212225","name":"Enzo Roco","rating":"75","photo":"./data/images/photos/1/212225.png","club":{"name":"Cruz Azul","logo":"./data/images/clubs/CruzAzul.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EnzoRoco0.json
// module id = 1263
// module chunks = 0